/**
 * Sportlink WordPress Plugin - Frontend JavaScript
 *
 * @version 4.0
 */

/* global spwp_object, Handlebars */

/**
 * Configuration object for Sportlink WordPress plugin
 *
 * @type {Object}
 * @property {Object}  LOGO                        - Club logo configuration
 * @property {string}  LOGO.BASE_URL               - Base URL for club logos
 * @property {Object}  LOGO.SIZES                  - Available logo sizes
 * @property {number}  LOGO.SIZES.SMALL            - Small logo size (50px)
 * @property {number}  LOGO.SIZES.MEDIUM           - Medium logo size (200px)
 * @property {number}  LOGO.SIZES.LARGE            - Large logo size (500px)
 * @property {Object}  UI                          - User interface configuration
 * @property {Object}  UI.ACCORDION                - jQuery UI Accordion settings
 * @property {boolean} UI.ACCORDION.COLLAPSIBLE    - Allow collapsing all sections
 * @property {string}  UI.ACCORDION.HEIGHT_STYLE   - Height calculation mode
 * @property {number}  UI.ACCORDION.ACTIVE_INDEX   - Initially active section index
 * @property {boolean} UI.ACCORDION.ACTIVE_NONE    - No active section on load
 * @property {Object}  MESSAGES                    - User-facing messages
 * @property {string}  MESSAGES.NO_RESULTS         - Message when no results found
 * @property {string}  MESSAGES.NO_PROGRAM         - Message when no program available
 * @property {string}  MESSAGES.CANCELLED          - Label for cancelled matches
 * @property {Object}  CONSTANTS                   - Miscellaneous constants
 * @property {number}  CONSTANTS.MIN_ELEMENT_COUNT - Minimum count to consider element present
 * @property {string}  CONSTANTS.PERIOD_PREFIX     - Prefix for period labels
 */
const SPWP_CONFIG = {
	LOGO: {
		BASE_URL: 'https://www.sportlinkwordpress.nl/clubs/',
		SIZES: {
			SMALL: 50,
			MEDIUM: 200,
			LARGE: 500,
		},
	},
	UI: {
		ACCORDION: {
			COLLAPSIBLE: true,
			HEIGHT_STYLE: 'content',
			ACTIVE_INDEX: 0,
			ACTIVE_NONE: false,
		},
	},
	MESSAGES: {
		NO_RESULTS: 'Op dit moment zijn er geen uitslagen bekend.',
		NO_PROGRAM: 'Op dit moment is er geen programma bekend.',
		CANCELLED: 'afgelast',
	},
	CONSTANTS: {
		MIN_ELEMENT_COUNT: 1,
		PERIOD_PREFIX: 'Periode ',
	},
};

jQuery(document).ready(function ($) {
	const api_url = spwp_object.api_url;
	const wp_cache_enabled = !!spwp_object.wp_cache;

	$('.spwp_tabjes').each(function () {
		$(this).tabs();
	});

	if ($('#spwp_tabs-99').length >= SPWP_CONFIG.CONSTANTS.MIN_ELEMENT_COUNT) {
		$('#spwp_tabs-99').accordion({
			collapsible: SPWP_CONFIG.UI.ACCORDION.COLLAPSIBLE,
			active: SPWP_CONFIG.UI.ACCORDION.ACTIVE_INDEX,
			heightStyle: SPWP_CONFIG.UI.ACCORDION.HEIGHT_STYLE,
		});
	}

	/**
	 * Helper function to generate club logo URL
	 *
	 * @param {string} clubCode - Club relation code
	 * @param {number} size     - Logo size (50, 200, or 500)
	 * @return {string} Full URL to club logo
	 */
	function spwp_getClubLogoUrl(clubCode, size) {
		return SPWP_CONFIG.LOGO.BASE_URL + size + '/' + clubCode + '.png';
	}

	/**
	 * Parse pipe-separated client IDs
	 *
	 * @param {string} clientIds - Client IDs separated by pipes
	 * @return {Array} Array of client IDs
	 */
	function spwp_parseClientIds(clientIds) {
		if (!clientIds || typeof clientIds !== 'string') {
			return [clientIds];
		}
		return clientIds.split('|').map((id) => id.trim()).filter((id) => id.length > 0);
	}

	/**
	 * Fetch data from multiple client IDs and merge results with server-side caching
	 *
	 * @param {string} endpoint  - API endpoint
	 * @param {Object} params    - Query parameters
	 * @param {string} clientIds - Client IDs (pipe-separated)
	 * @param {number} cacheTtl  - Cache duration in seconds (default 86400 = 1 day)
	 * @return {Promise} Promise that resolves to merged data array
	 */
	function spwp_fetchAndMergeMultipleClients(endpoint, params, clientIds, cacheTtl) {
		const ids = spwp_parseClientIds(clientIds);
		cacheTtl = wp_cache_enabled ? (cacheTtl ?? 86400) : 0;

		// Generate cache key
		const cacheKey = spwp_generateCacheKey(endpoint, clientIds, params);

		// Try to get cached data first
		if (cacheTtl > 0) {
			return spwp_getCache(cacheKey).then((cachedData) => {
				if (cachedData && Array.isArray(cachedData) && cachedData.length > 0) {
					// console.log('Using cached data for ' + endpoint);
					return cachedData;
				}
				
				// No cache, fetch from API
				return spwp_fetchFromAPI(ids, endpoint, params).then((data) => {
					// Only cache if we got valid data
					if (data && Array.isArray(data) && data.length > 0) {
						spwp_setCache(cacheKey, data, cacheTtl);
					}
					return data;
				}).catch((error) => {
					// console.error('API request failed for ' + endpoint, error);
					// Return empty array on API failure
					return [];
				});
			});
		}

		// Cache disabled, fetch directly from API
		return spwp_fetchFromAPI(ids, endpoint, params).then((data) => {
			return data;
		}).catch((error) => {
			// console.error('API request failed for ' + endpoint, error);
			return [];
		});
	}

	/**
	 * Fetch all team data sections at once (combined cache request)
	 *
	 * @param {Object} sectionsConfig - Configuration for all sections
	 * @param {string} clientIds      - Client IDs (pipe-separated)
	 * @param {number} cacheTtl       - Cache duration in seconds
	 * @return {Promise} Promise that resolves to combined data object
	 */
	function spwp_fetchTeamDataCombined(sectionsConfig, clientIds, cacheTtl) {
		const ids = spwp_parseClientIds(clientIds);
		cacheTtl = wp_cache_enabled ? (cacheTtl ?? 86400) : 0;

		// Create cache key for combined team data
		const teamCacheKey = 'sw_team_' + JSON.stringify(sectionsConfig).substring(0, 20);
		let hash = 0;
		for (let i = 0; i < teamCacheKey.length; i++) {
			const char = teamCacheKey.charCodeAt(i);
			hash = ((hash << 5) - hash) + char;
			hash = hash & hash;
		}
		const shortHash = Math.abs(hash).toString(36).substring(0, 6);
		const cacheKey = 'team_' + shortHash + '.json';

		// Try to get combined cached data
		if (cacheTtl > 0) {
			return spwp_getCache(cacheKey).then((cachedData) => {
				if (cachedData && typeof cachedData === 'object' && Object.keys(cachedData).length > 0) {
					// console.log('Using combined cached team data');
					return cachedData;
				}

				// No cache, fetch all sections in parallel
				const requests = [];
				const sectionKeys = [];

				for (const section in sectionsConfig) {
					if (sectionsConfig.hasOwnProperty(section)) {
						const config = sectionsConfig[section];
						sectionKeys.push(section);
						requests.push(
							spwp_fetchFromAPI(ids, config.endpoint, config.params)
						);
					}
				}

				return $.when.apply($, requests).then(function () {
					const responses = Array.prototype.slice.call(arguments);
					const combinedData = {};

					sectionKeys.forEach((section, index) => {
						combinedData[section] = responses[index] || [];
					});

					// Cache the combined result
					if (Object.keys(combinedData).length > 0) {
						spwp_setCache(cacheKey, combinedData, cacheTtl);
					}

					return combinedData;
				}).catch((error) => {
					// console.error('Combined team request failed', error);
					return {};
				});
			});
		}

		// Cache disabled, fetch directly
		const requests = [];
		const sectionKeys = [];

		for (const section in sectionsConfig) {
			if (sectionsConfig.hasOwnProperty(section)) {
				const config = sectionsConfig[section];
				sectionKeys.push(section);
				requests.push(
					spwp_fetchFromAPI(ids, config.endpoint, config.params)
				);
			}
		}

		return $.when.apply($, requests).then(function () {
			const responses = Array.prototype.slice.call(arguments);
			const combinedData = {};

			sectionKeys.forEach((section, index) => {
				combinedData[section] = responses[index] || [];
			});

			return combinedData;
		}).catch((error) => {
			// console.error('Combined team request failed', error);
			return {};
		});
	}

	/**
	 * Fetch data from API (helper function)
	 *
	 * @param {Array}  ids      - Array of client IDs
	 * @param {string} endpoint - API endpoint
	 * @param {Object} params   - Query parameters
	 * @return {Promise} Promise that resolves to data array
	 */
	function spwp_fetchFromAPI(ids, endpoint, params) {
		// Validate inputs
		if (!endpoint || endpoint === 'null' || !ids || ids.length === 0) {
			// console.error('Invalid endpoint or client IDs for API request', { endpoint: endpoint, ids: ids });
			return $.Deferred().reject('Invalid API parameters').promise();
		}

		if (ids.length === 1) {
			const url = api_url + endpoint + '?' + $.param({ ...params, client_id: ids[0] });
			// console.log('API Request:', url);
			return $.getJSON(url).then((data) => {
				return Array.isArray(data) ? data : [data];
			}).catch((error) => {
				// console.error('API request failed for ' + endpoint, error);
				return [];
			});
		}

		const requests = ids.map((id) => {
			const url = api_url + endpoint + '?' + $.param({ ...params, client_id: id });
			// console.log('API Request:', url);
			return $.getJSON(url).then((data) => {
				return Array.isArray(data) ? data : [data];
			}).catch((error) => {
				// console.error('API request failed for ' + endpoint, error);
				return [];
			});
		});

		return $.when.apply($, requests).then(function () {
			let merged = [];
			const responses = Array.prototype.slice.call(arguments);
			responses.forEach((response) => {
				if (Array.isArray(response[0])) {
					merged = merged.concat(response[0]);
				} else {
					merged = merged.concat(response);
				}
			});
			return spwp_deduplicateAndSortData(merged);
		});
	}

	/**
	 * Deduplicate items and sort by date
	 *
	 * @param {Array} items - Items to deduplicate
	 * @return {Array} Deduplicated and sorted array
	 */
	function spwp_deduplicateAndSortData(items) {
		const seen = new Set();
		const unique = [];

		items.forEach((item) => {
			const key = item.wedstrijdcode || item.vrijwilligerstaakcode || JSON.stringify(item);
			if (!seen.has(key)) {
				seen.add(key);
				unique.push(item);
			}
		});

		unique.sort((a, b) => {
			const dateA = new Date(a.wedstrijddatum || a.datumvan || 0);
			const dateB = new Date(b.wedstrijddatum || b.datumvan || 0);
			return dateA - dateB;
		});

		return unique;
	}

	/**
	 * Generate a unique cache key for shortcode
	 *
	 * @param {string} article    - Article type (programma, uitslagen, etc.)
	 * @param {string} clientIds  - Client IDs
	 * @param {Object} params     - Query parameters
	 * @return {string} Cache key hash
	 */
	function spwp_generateCacheKey(article, clientIds, params) {
		const keyData = {
			article: article,
			clientIds: clientIds,
			params: params,
		};
		const keyString = JSON.stringify(keyData);
		let hash = 0;
		for (let i = 0; i < keyString.length; i++) {
			const char = keyString.charCodeAt(i);
			hash = ((hash << 5) - hash) + char;
			hash = hash & hash;
		}
		const shortHash = Math.abs(hash).toString(36).substring(0, 6);
		return article + '_' + shortHash + '.json';
	}

	/**
	 * Get cached data from server
	 *
	 * @param {string} cacheKey - Cache key
	 * @return {Promise} Promise resolving to cached data or null
	 */
	function spwp_getCache(cacheKey) {
		return $.ajax({
			url: spwp_object.rest_url + '/cache',
			type: 'GET',
			data: {
				cache_key: cacheKey,
			},
			dataType: 'json',
		}).then((response) => {
			if (response.success && response.data) {
				return response.data;
			}
			return null;
		}).catch(() => {
			return null;
		});
	}

	/**
	 * Save data to cache
	 *
	 * @param {string} cacheKey - Cache key
	 * @param {*}      data     - Data to cache
	 * @param {number} ttl      - Time to live in seconds
	 * @return {Promise} Promise
	 */
	function spwp_setCache(cacheKey, data, ttl) {
		ttl = ttl || 3600;
		return $.ajax({
			url: spwp_object.rest_url + '/cache',
			type: 'POST',
			data: {
				cache_key: cacheKey,
				data: JSON.stringify(data),
				ttl: ttl,
			},
			dataType: 'json',
		}).catch(() => {
			return null;
		});
	}

	/**
	 * Clear cache (both localStorage and server)
	 *
	 * @param {string} pattern - Cache pattern to clear (default: '*')
	 * @return {Promise} Promise
	 */
	function spwp_clearCache(pattern) {
		pattern = pattern || '*';
		
		// Clear localStorage cache
		if (pattern === '*') {
			const keys = [];
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key.startsWith('spwp_cache_')) {
					keys.push(key);
				}
			}
			keys.forEach((key) => {
				localStorage.removeItem(key);
			});
			// console.log('Cleared ' + keys.length + ' localStorage cache entries');
		} else {
			// Clear by pattern
			const keys = [];
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key.startsWith('spwp_cache_') && key.includes(pattern)) {
					keys.push(key);
				}
			}
			keys.forEach((key) => {
				localStorage.removeItem(key);
			});
		}
		
		return $.ajax({
			url: spwp_object.rest_url + '/cache/clear',
			type: 'POST',
			data: {
				pattern: pattern,
			},
			dataType: 'json',
		}).catch(() => {
			return null;
		});
	}

	/**
	 * Generate home team HTML with logo
	 *
	 * @param {string} teamName - Team name
	 * @param {string} logoUrl  - URL to team logo
	 * @return {string} HTML string for home team display
	 */
	function spwp_generateHomeTeamHtml(teamName, logoUrl) {
		return (
			'<div class="thuisteam team">' +
			teamName +
			'</div>' +
			'<div class="thuisteamLogo"><img class="clublogo" src="' +
			logoUrl +
			'"></div>'
		);
	}

	/**
	 * Generate away team HTML with logo
	 *
	 * @param {string} teamName - Team name
	 * @param {string} logoUrl  - URL to team logo
	 * @return {string} HTML string for away team display
	 */
	function spwp_generateAwayTeamHtml(teamName, logoUrl) {
		return (
			'<div class="uitteamLogo"><img class="clublogo" src="' +
			logoUrl +
			'"></div>' +
			'<div class="uitteam team">' +
			teamName +
			'</div>'
		);
	}

	/**
	 * Generate team HTML based on sport type and field
	 *
	 * @param {string} fieldKey  - Field key (thuisteam or uitteam)
	 * @param {string} teamName  - Team name value
	 * @param {Object} row       - Full row data
	 * @param {string} typeSport - Sport type (voetbal, honkbal, etc.)
	 * @param {number} logoSize  - Logo size to use
	 * @return {string} HTML string for team display
	 */
	function spwp_generateTeamHtml(fieldKey, teamName, row, typeSport, logoSize) {
		if (typeSport !== 'voetbal') {
			const logoUrl =
				fieldKey === 'thuisteam' ? row.thuisteamlogo : row.uitteamlogo;
			return fieldKey === 'thuisteam'
				? spwp_generateHomeTeamHtml(teamName, logoUrl)
				: spwp_generateAwayTeamHtml(teamName, logoUrl);
		}
		const clubCodeField =
			fieldKey === 'thuisteam'
				? 'thuisteamclubrelatiecode'
				: 'uitteamclubrelatiecode';
		const logoUrl = spwp_getClubLogoUrl(row[clubCodeField], logoSize);
		return fieldKey === 'thuisteam'
			? spwp_generateHomeTeamHtml(teamName, logoUrl)
			: spwp_generateAwayTeamHtml(teamName, logoUrl);
	}

	/**
	 * Format date for program display (DD Mon. HH:MM)
	 *
	 * @param {string} dataValue - Date string to format
	 * @return {string} Formatted date and time
	 */
	function spwp_formatProgrammaDate(dataValue) {
		const date = new Date(dataValue);

		const maanden = [
			'Jan.',
			'Feb.',
			'Mrt.',
			'Apr.',
			'Mei',
			'Jun.',
			'Jul.',
			'Aug.',
			'Sep.',
			'Okt.',
			'Nov.',
			'Dec.',
		];
		const dag = date.getDate();
		const maand = maanden[date.getMonth()];

		let hour = date.getHours();
		hour = hour > 9 ? hour : '0' + hour;
		let minutes = date.getMinutes();
		minutes = minutes > 9 ? minutes : '0' + minutes;

		return dag + ' ' + maand + ' ' + hour + ':' + minutes;
	}

	/**
	 * Process a single data field value
	 *
	 * @param {string} fieldKey   - Field key being processed
	 * @param {*}      fieldValue - Field value
	 * @param {Object} row        - Full row data
	 * @param {string} typeSport  - Sport type
	 * @param {string} weergave   - Display mode (tabel or default)
	 * @param {number} logoSize   - Logo size to use
	 * @return {*} Processed field value
	 */
	function spwp_processFieldValue(
		fieldKey,
		fieldValue,
		row,
		typeSport,
		weergave,
		logoSize
	) {
		if (spwp_is_null_or_undef(fieldValue) === false) {
			return fieldKey === 'uitslag' ? SPWP_CONFIG.MESSAGES.CANCELLED : '';
		}

		if (
			fieldKey === 'wedstrijddatum' ||
			fieldKey === 'datumvan' ||
			fieldKey === 'datumtm' ||
			fieldKey === 'startdatum' ||
			fieldKey === 'einddatum'
		) {
			return spwp_formatProgrammaDate(fieldValue);
		}

		if (weergave === 'tabel') {
			return spwp_processTableFieldValue(
				fieldKey,
				fieldValue,
				row,
				typeSport,
				logoSize
			);
		}

		return spwp_processDefaultFieldValue(
			fieldKey,
			fieldValue,
			row,
			typeSport,
			logoSize
		);
	}

	/**
	 * Process field value for table display
	 *
	 * @param {string} fieldKey   - Field key
	 * @param {*}      fieldValue - Field value
	 * @param {Object} row        - Row data
	 * @param {string} typeSport  - Sport type
	 * @param {number} logoSize   - Logo size
	 * @return {*} Processed value for table
	 */
	function spwp_processTableFieldValue(
		fieldKey,
		fieldValue,
		row,
		typeSport,
		logoSize
	) {
		if (typeSport !== 'voetbal') {
			if (fieldKey === 'thuisteamlogo') {
				var thuisSrc = spwp_getClubLogoUrl(row.thuisteamclubrelatiecode, logoSize);
				var thuisFallback = thuisSrc + '?source=' + encodeURIComponent(fieldValue);
				return '<img class="clublogo" src="' + thuisSrc + '" onerror="this.onerror=null;this.src=\'' + thuisFallback + '\'">';
			}
			else if (fieldKey === 'uitteamlogo') {
				var uitSrc = spwp_getClubLogoUrl(row.uitteamclubrelatiecode, logoSize);
				var uitFallback = uitSrc + '?source=' + encodeURIComponent(fieldValue);
				return '<img class="clublogo" src="' + uitSrc + '" onerror="this.onerror=null;this.src=\'' + uitFallback + '\'">';
			}
			return fieldValue;
		}

		if (fieldKey === 'thuisteam') {
			return (
				'<img class="clublogo" src="' +
				spwp_getClubLogoUrl(row.thuisteamclubrelatiecode, logoSize) +
				'">' +
				fieldValue
			);
		}
		if (fieldKey === 'uitteam') {
			return (
				'<img class="clublogo" src="' +
				spwp_getClubLogoUrl(row.uitteamclubrelatiecode, logoSize) +
				'">' +
				fieldValue
			);
		}
		return fieldValue;
	}

	/**
	 * Process field value for default display
	 *
	 * @param {string} fieldKey   - Field key
	 * @param {*}      fieldValue - Field value
	 * @param {Object} row        - Row data
	 * @param {string} typeSport  - Sport type
	 * @param {number} logoSize   - Logo size
	 * @return {*} Processed value
	 */
	function spwp_processDefaultFieldValue(
		fieldKey,
		fieldValue,
		row,
		typeSport,
		logoSize
	) {
		if (fieldKey === 'thuisteam' || fieldKey === 'uitteam') {
			return spwp_generateTeamHtml(
				fieldKey,
				fieldValue,
				row,
				typeSport,
				logoSize
			);
		}
		if (fieldKey === 'teamnaam' && typeSport === 'voetbal') {
			const clubCode = row.clubrelatiecode || row.clubcode;
			return (
				'<img class="clublogo" src="' +
				spwp_getClubLogoUrl(clubCode, SPWP_CONFIG.LOGO.SIZES.SMALL) +
				'"> ' +
				fieldValue
			);
		}
		return fieldValue;
	}

	/**
	 * Transform API data rows into processed items based on field configuration
	 *
	 * @param {Array}  data      - Raw API data
	 * @param {Array}  fields    - Fields to extract
	 * @param {string} typeSport - Sport type
	 * @param {string} weergave  - Display mode
	 * @param {number} logoSize  - Logo size (default: MEDIUM)
	 * @return {Array} Processed items
	 */
	function spwp_transformDataRows(data, fields, typeSport, weergave, logoSize) {
		logoSize = logoSize || SPWP_CONFIG.LOGO.SIZES.MEDIUM;
		const items = [];

		$.each(data, function (key, row) {
			const obj = {};

			$.each(fields, function (index, field) {
				if (row.hasOwnProperty(field)) {
					obj[field] = spwp_processFieldValue(
						field,
						row[field],
						row,
						typeSport,
						weergave,
						logoSize
					);
				}
			});

			items.push(obj);
		});

		return items;
	}

	/**
	 * Cache store for combined team data to avoid duplicate requests
	 */
	const spwp_teamDataCache = {};

	/**
	 * Process team section data from combined request
	 */
	function spwp_processTeamSection(container, spwp_data, teamData, type_sport) {
		const article = spwp_data.data('article');
		const data = teamData[article] || [];

		if (article === 'poulestand') {
			const pouleParams = {
				poulecode: spwp_data.data('param-poulecode'),
				gebruiklokaleteamgegevens: spwp_data.data('param-gebruiklokaleteamgegevens'),
				fields: spwp_data.data('fields').split(','),
			};

			const template = Handlebars.compile(spwp_object.templates.poule_stand);
			const items = pouleParams.fields
				? spwp_transformDataRows(data, pouleParams.fields, type_sport, null, SPWP_CONFIG.LOGO.SIZES.SMALL)
				: data;

			container.append(
				template({
					sport: type_sport,
					items,
					fields: pouleParams.fields,
					labels: spwp_object.labels,
				})
			);
		} else if (article === 'periodestand') {
			const periodeParams = {
				periodenummer: spwp_data.data('param-periodenummer'),
				fields: spwp_data.data('fields').split(','),
			};

			const template = Handlebars.compile(spwp_object.templates.periode_stand);
			let items = [];
			if (periodeParams.fields && data.length >= SPWP_CONFIG.CONSTANTS.MIN_ELEMENT_COUNT) {
				const $selectPeriode = $('#spwp_select_periode');
				$selectPeriode.append(
					$('<option>', {
						value: 'sw_periodestand_' + periodeParams.periodenummer,
						text: SPWP_CONFIG.CONSTANTS.PERIOD_PREFIX + periodeParams.periodenummer,
					})
				);

				const options = $selectPeriode.find('option');
				options.sort(function (a, b) {
					return $(a).val().localeCompare($(b).val());
				});
				$selectPeriode.html(options);

				items = spwp_transformDataRows(data, periodeParams.fields, type_sport, null, SPWP_CONFIG.LOGO.SIZES.SMALL);
			} else if (!periodeParams.fields) {
				items = data;
			}

			container.append(
				template({
					sport: type_sport,
					items,
					fields: periodeParams.fields,
					labels: spwp_object.labels,
				})
			);
		} else if (article === 'pouleuitslagen') {
			const pouleUitParams = {
				poulecode: spwp_data.data('param-poulecode'),
				eigenwedstrijden: spwp_data.data('param-eigenwedstrijden'),
				gebruiklokaleteamgegevens: spwp_data.data('param-gebruiklokaleteamgegevens'),
				aantaldagen: spwp_data.data('param-aantaldagen'),
				weekoffset: spwp_data.data('param-weekoffset'),
				fields: spwp_data.data('fields').split(','),
			};

			const template = Handlebars.compile(spwp_object.templates.poule_uitslagen);
			const items = pouleUitParams.fields
				? spwp_transformDataRows(data, pouleUitParams.fields, type_sport)
				: data;

			if (items.length === 0) {
				container.append('<p>' + SPWP_CONFIG.MESSAGES.NO_RESULTS + '</p>');
			} else {
				container.append(
					template({
						sport: type_sport,
						items,
						fields: pouleUitParams.fields,
						labels: spwp_object.labels,
					})
				);
			}
		} else if (article === 'poule-programma') {
			const pouleProgParams = {
				poulecode: spwp_data.data('param-poulecode'),
				aantaldagen: spwp_data.data('param-aantaldagen'),
				weekoffset: spwp_data.data('param-weekoffset'),
				gebruiklokaleteamgegevens: spwp_data.data('param-gebruiklokaleteamgegevens'),
				eigenwedstrijden: spwp_data.data('param-eigenwedstrijden'),
				fields: spwp_data.data('fields').split(','),
			};

			const template = Handlebars.compile(spwp_object.templates.poule_programma);
			const items = pouleProgParams.fields
				? spwp_transformDataRows(data, pouleProgParams.fields, type_sport)
				: data;

			if (items.length === 0) {
				container.append('<p>' + SPWP_CONFIG.MESSAGES.NO_PROGRAM + '</p>');
			} else {
				container.append(
					template({
						sport: type_sport,
						items,
						fields: pouleProgParams.fields,
						labels: spwp_object.labels,
					})
				);
				spwp_addToggleForEachContainer();
			}
		} else if (article === 'team-indeling') {
			const teamIndelingParams = {
				fields: spwp_data.data('fields').split(','),
			};

			const template = Handlebars.compile(spwp_object.templates.team_indeling);
			const items = teamIndelingParams.fields
				? spwp_transformDataRows(data, teamIndelingParams.fields, type_sport)
				: data;

			if (items.length === 0) {
				container.hide();
				$('#spwp_tabs-100').hide();
				$('#tab_selectie').hide();
			} else {
				container.append(
					template({
						sport: type_sport,
						items,
						fields: teamIndelingParams.fields,
						labels: spwp_object.labels,
					})
				);
			}
		}
	}

	/**
	 * Add toggle functionality for compact displays
	 */
	function spwp_addToggleForEachContainer() {
		const programmaContainers = $('.compact_overzicht');

		programmaContainers.each(function () {
			const programmaRegels = $(this).find('.regel');

			if ($(this).hasClass('extradata')) {
				programmaRegels.each(function () {
					const toonMeerButton = $(this).find('.mainData');
					const extradataDiv = $(this).find('.extradata');

					// console.log( toonMeerButton );

					if (toonMeerButton.length > 0 && extradataDiv.length > 0) {
						toonMeerButton.off('click', spwp_toggleExtraDataDisplay);
						toonMeerButton.on('click', spwp_toggleExtraDataDisplay);
					}
				});
			} else {
				programmaRegels.each(function () {
					$(this).find('.toonmeer').hide();
				});
			}
		});
	}

	/**
	 * Check cache and fetch team data for #spwp_tabs
	 * All data is loaded as one combined unit from cache or API
	 */
	function spwp_checkAndFetchTeamTabsCache(teamSections) {
		if (teamSections.length === 0) return;

		const firstSection = teamSections[0];
		const $firstData = firstSection.$container.find('.spwp_data');
		const clientIds = $firstData.data('client_id');
		const teamCode = $firstData.data('param-teamcode') || 'default';

		// console.log('Checking cache for #spwp_tabs team:', teamCode);

		$.ajax({
			url: spwp_object.rest_url + '/team-cache',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				team_code: teamCode,
				client_ids: clientIds,
				check_only: true,
			}),
			success: function (response) {
				if (response.success && response.data && response.cached) {
					// console.log('Cache hit for #spwp_tabs team:', teamCode);
					teamSections.forEach((section, index) => {
						const article = section.$data.data('article');
						const cached = response.data['section_' + index] || response.data[article] || [];
						spwp_processTeamSection(section.$container, section.$data, { [article]: cached }, section.type_sport);
					});
				} else {
					// console.log('Cache miss for #spwp_tabs team:', teamCode);
					spwp_fetchTeamTabsData(teamSections, clientIds, teamCode);
				}
			},
			error: function () {
				// console.log('Cache check failed, fetching from API');
				spwp_fetchTeamTabsData(teamSections, clientIds, teamCode);
			},
		});
	}

	/**
	 * Fetch team data from API for #spwp_tabs and save as combined cache
	 */
	function spwp_fetchTeamTabsData(teamSections, clientIds, teamCode) {
		const ids = spwp_parseClientIds(clientIds);
		const requests = [];
		const sectionArticles = [];

		teamSections.forEach((section) => {
			const article = section.$data.data('article');
			const params = {};

			if (article === 'poulestand') {
				params.poulecode = section.$data.data('param-poulecode');
				params.gebruiklokaleteamgegevens = section.$data.data('param-gebruiklokaleteamgegevens');
			} else if (article === 'periodestand') {
				params.poulecode = section.$data.data('param-poulecode');
				params.periodenummer = section.$data.data('param-periodenummer');
			} else if (article === 'pouleuitslagen') {
				params.poulecode = section.$data.data('param-poulecode');
				params.eigenwedstrijden = section.$data.data('param-eigenwedstrijden');
				params.gebruiklokaleteamgegevens = section.$data.data('param-gebruiklokaleteamgegevens');
				params.aantaldagen = section.$data.data('param-aantaldagen');
				params.weekoffset = section.$data.data('param-weekoffset');
			} else if (article === 'poule-programma') {
				params.poulecode = section.$data.data('param-poulecode');
				params.aantaldagen = section.$data.data('param-aantaldagen');
				params.weekoffset = section.$data.data('param-weekoffset');
				params.gebruiklokaleteamgegevens = section.$data.data('param-gebruiklokaleteamgegevens');
				params.eigenwedstrijden = section.$data.data('param-eigenwedstrijden');
			} else if (article === 'team-indeling') {
				params.teamcode = section.$data.data('param-teamcode');
				params.lokaleteamcode = section.$data.data('param-lokaleteamcode');
				params.teampersoonrol = section.$data.data('param-teampersoonrol');
				params.toonlidfoto = section.$data.data('param-toonlidfoto');
			}

			sectionArticles.push(article);

			const fullParams = {
				...params,
				client_id: ids[0],
			};

			const url = 'https://data.sportlink.com/' + article + '?' + $.param(fullParams);
			// console.log('Fetching from API:', article);

			requests.push(
				$.ajax({
					url: url,
					method: 'GET',
					dataType: 'json',
				}).promise()
			);
		});

		// Wait for all requests to complete
		$.when.apply($, requests).done(function () {
			const responses = Array.prototype.slice.call(arguments);
			const normalizedResponses = requests.length === 1 ? [responses] : responses;

			const cacheData = {};
			teamSections.forEach((section, index) => {
				const article = section.$data.data('article');
				const rawData = normalizedResponses[index][0] || [];
				const sectionData = Array.isArray(rawData) ? rawData : [rawData];
				cacheData['section_' + index] = sectionData;
				cacheData[article] = sectionData;
				spwp_processTeamSection(section.$container, section.$data, { [article]: sectionData }, section.type_sport);
			});

			if (wp_cache_enabled && Object.keys(cacheData).length > 0) {
				$.ajax({
					url: spwp_object.rest_url + '/team-cache',
					method: 'POST',
					contentType: 'application/json',
					data: JSON.stringify({
						team_code: teamCode,
						client_ids: clientIds,
						save_only: true,
						data: cacheData,
					}),
				});
			}
		}).fail(function () {
			// console.error('API requests failed for #spwp_tabs team:', teamCode);
			teamSections.forEach((section) => {
				const article = section.$data.data('article');
				spwp_processTeamSection(section.$container, section.$data, { [article]: [] }, section.type_sport);
			});
		});
	}

	/**
	 * Fetch team data: check cache first, then use jQuery for API calls if no cache
	 */
	function spwp_fetchTeamDataBulk(teamSections) {
		if (teamSections.length === 0) return;

		const firstSection = teamSections[0];
		const $firstData = firstSection.$container.find('.spwp_data');
		const clientIds = $firstData.data('client_id');
		const ids = spwp_parseClientIds(clientIds);
		const teamCode = $firstData.data('param-teamcode') || 'team';

		if (!wp_cache_enabled) {
			spwp_fetchTeamDataWithJQuery(teamSections, ids, clientIds, teamCode);
			return;
		}

		// console.log('Checking cache for team:', teamCode);

		$.ajax({
			url: spwp_object.rest_url + '/team-cache',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				team_code: teamCode,
				client_ids: clientIds,
				check_only: true,
			}),
			success: function (response) {
				if (response.success && response.data && response.cached) {
					// console.log('Cache hit for team:', teamCode);
					teamSections.forEach((section, index) => {
						const article = section.$data.data('article');
						const cached = response.data['section_' + index] || response.data[article] || [];
						spwp_processTeamSection(section.$container, section.$data, { [article]: cached }, section.type_sport);
					});
				} else {
					// console.log('Cache miss for team:', teamCode, '- fetching from API');
					spwp_fetchTeamDataWithJQuery(teamSections, ids, clientIds, teamCode);
				}
			},
			error: function () {
				// console.log('Cache check failed - fetching from API');
				spwp_fetchTeamDataWithJQuery(teamSections, ids, clientIds, teamCode);
			},
		});
	}

	/**
	 * Fetch team data from Sportlink API using jQuery, one request per section
	 */
	function spwp_fetchTeamDataWithJQuery(teamSections, ids, clientIds, teamCode) {
		const requests = [];

		teamSections.forEach((section) => {
			const article = section.$data.data('article');
			const params = { client_id: ids[0] };

			if (article === 'poulestand') {
				params.poulecode = section.$data.data('param-poulecode');
				params.gebruiklokaleteamgegevens = section.$data.data('param-gebruiklokaleteamgegevens');
			} else if (article === 'periodestand') {
				params.poulecode = section.$data.data('param-poulecode');
				params.periodenummer = section.$data.data('param-periodenummer');
			} else if (article === 'pouleuitslagen') {
				params.poulecode = section.$data.data('param-poulecode');
				params.eigenwedstrijden = section.$data.data('param-eigenwedstrijden');
				params.gebruiklokaleteamgegevens = section.$data.data('param-gebruiklokaleteamgegevens');
				params.aantaldagen = section.$data.data('param-aantaldagen');
				params.weekoffset = section.$data.data('param-weekoffset');
			} else if (article === 'poule-programma') {
				params.poulecode = section.$data.data('param-poulecode');
				params.aantaldagen = section.$data.data('param-aantaldagen');
				params.weekoffset = section.$data.data('param-weekoffset');
				params.gebruiklokaleteamgegevens = section.$data.data('param-gebruiklokaleteamgegevens');
				params.eigenwedstrijden = section.$data.data('param-eigenwedstrijden');
			} else if (article === 'team-indeling') {
				params.teamcode = section.$data.data('param-teamcode');
				params.lokaleteamcode = section.$data.data('param-lokaleteamcode');
				params.teampersoonrol = section.$data.data('param-teampersoonrol');
				params.toonlidfoto = section.$data.data('param-toonlidfoto');
			}

			const url = 'https://data.sportlink.com/' + article + '?' + $.param(params);
			// console.log('jQuery request to:', article, url);
			requests.push($.ajax({ url: url, method: 'GET', dataType: 'json' }).promise());
		});

		$.when.apply($, requests).done(function () {
			const responses = Array.prototype.slice.call(arguments);
			const normalizedResponses = requests.length === 1 ? [responses] : responses;

			const cacheData = {};
			teamSections.forEach((section, index) => {
				const article = section.$data.data('article');
				const rawData = normalizedResponses[index][0] || [];
				const sectionData = Array.isArray(rawData) ? rawData : [rawData];
				cacheData['section_' + index] = sectionData;
				cacheData[article] = sectionData;
				spwp_processTeamSection(section.$container, section.$data, { [article]: sectionData }, section.type_sport);
			});

			if (wp_cache_enabled && Object.keys(cacheData).length > 0) {
				$.ajax({
					url: spwp_object.rest_url + '/team-cache',
					method: 'POST',
					contentType: 'application/json',
					data: JSON.stringify({
						team_code: teamCode,
						client_ids: clientIds,
						save_only: true,
						data: cacheData,
					}),
				});
			}
		}).fail(function () {
			// console.error('jQuery requests failed for team:', teamCode);
			teamSections.forEach((section) => {
				const article = section.$data.data('article');
				spwp_processTeamSection(section.$container, section.$data, { [article]: [] }, section.type_sport);
			});
		});
	}

	/**
	 *
	 */

	/**
	 * Toggle display of extra data section
	 *
	 * @param {Event} event - Click event
	 */
	function spwp_toggleExtraDataDisplay(event) {
		const extradataDiv = event.currentTarget
			.closest('.regel')
			.querySelector('.extradata');

		if (extradataDiv) {
			if (extradataDiv.style.display === 'block') {
				extradataDiv.style.display = 'none';
			} else {
				extradataDiv.style.display = 'block';
			}
		}
	}

	function spwp_request_data() {
		if (
			$('.spwp_container').length >=
			SPWP_CONFIG.CONSTANTS.MIN_ELEMENT_COUNT
		) {
			// Check if #spwp_tabs exists (team page with tabs)
			const hasTeamTabs = $('#spwp_tabs').length > 0;
			
			// Detect team sections for bulk processing
			const teamSectionArticles = ['poulestand', 'periodestand', 'pouleuitslagen', 'poule-programma', 'team-indeling'];
			const teamGroups = {};
			const processedContainers = new Set();

			$('.spwp_container').each(function () {
				const $container = $(this);
				const $data = $container.find('.spwp_data');
				const article = $data.data('article');

				if (teamSectionArticles.includes(article)) {
					const teamCode = $data.data('param-teamcode') || 'default';
				if (!teamGroups[teamCode]) {
					teamGroups[teamCode] = [];
				}
				teamGroups[teamCode].push({
						$container: $container,
						$data: $data,
						article: article,
						type_sport: $data.data('spwp-sport') || spwp_object.type_sport,
					});
					processedContainers.add(this);
				}
			});

			// Process each team's sections in bulk
			Object.keys(teamGroups).forEach((teamCode) => {

				// console.log( "teamgroups"+ teamGroups );

				if (teamGroups[teamCode].length > 0) {
					// If #spwp_tabs exists, check cache first before fetching
					if (hasTeamTabs) {
						spwp_checkAndFetchTeamTabsCache(teamGroups[teamCode]);
					} else {
						spwp_fetchTeamDataBulk(teamGroups[teamCode]);
					}
				}
			});

			$('.spwp_container').each(function () {
				// Skip team sections (already processed)
				if (processedContainers.has(this)) {
					return;
				}
				const container = $(this);
				container.addClass(spwp_object.type_sport);

				const spwp_data = $(this).find('.spwp_data');
				let type_sport = spwp_data.data('spwp-sport');
				if (
					type_sport === '' ||
					type_sport === undefined ||
					type_sport === null
				) {
					type_sport = spwp_object.type_sport;
				}

				if (spwp_data.data('article') === 'programma') {
				const clientIds = spwp_data.data('client_id');
				const cacheTtlProgramma = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
				const params = {
						//type_sport : spwp_data.data("sport"),
						gebruiklokaleteamgegevens: spwp_data.data(
							'param-gebruiklokaleteamgegevens'
						),
						aantaldagen: spwp_data.data('param-aantaldagen'),
						aantalregels: spwp_data.data('param-aantalregels'),
						weekoffset: spwp_data.data('param-weekoffset'),
						eigenwedstrijden: spwp_data.data(
							'param-eigenwedstrijden'
						),
						thuis: spwp_data.data('param-thuis'),
						uit: spwp_data.data('param-uit'),
						sorteervolgorde: spwp_data.data(
							'param-sorteervolgorde'
						),
						spelsoort: spwp_data.data('param-spelsoort'),
						leeftijdscategorie: spwp_data.data(
							'param-leeftijdscategorie'
						),
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('programma', params, clientIds, cacheTtlProgramma).then(
						function (data) {
							let template = spwp_object.templates.programma;

							if (
								spwp_data.data('spwp-weergave') === 'tabel'
							) {
								template =
									spwp_object.templates.programma_tabel;
							}

							template = Handlebars.compile(template);

							const weergave = spwp_data.data('spwp-weergave');
							const items = params.fields
								? spwp_transformDataRows(
										data,
										params.fields,
										type_sport,
										weergave
									)
								: data;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: params.fields,
									labels: spwp_object.labels,
									extradata:
										spwp_data.data('spwp-extra_data'),
								})
							);

							spwp_addToggleForEachContainer();
							spwp_meer_wedstrijd_informatie(spwp_data);
						}
					).fail(function () {
						// Handle errors silently
					});
				} else if (spwp_data.data('article') === 'uitslagen') {
				const clientIds = spwp_data.data('client_id');
				const cacheTtlUitslagen = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
					const uitParams = {
						gebruiklokaleteamgegevens: spwp_data.data(
							'param-gebruiklokaleteamgegevens'
						),
						aantaldagen: spwp_data.data('param-aantaldagen'),
						weekoffset: spwp_data.data('param-weekoffset'),
						thuis: spwp_data.data('param-thuis'),
						uit: spwp_data.data('param-uit'),
						sorteervolgorde: spwp_data.data(
							'param-sorteervolgorde'
						),
						spelsoort: spwp_data.data('param-spelsoort'),
						leeftijdscategorie: spwp_data.data(
							'param-leeftijdscategorie'
						),
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('uitslagen', uitParams, clientIds, cacheTtlUitslagen).then(
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.uitslagen
							);
							const items = uitParams.fields
								? spwp_transformDataRows(
										data,
										uitParams.fields,
										type_sport
									)
								: data;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: uitParams.fields,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				} else if (spwp_data.data('article') === 'afgelastingen') {
				const clientIds = spwp_data.data('client_id');
				const cacheTtlAfgelastingen = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
					const afgelParams = {
						gebruiklokaleteamgegevens: spwp_data.data(
							'param-gebruiklokaleteamgegevens'
						),
						weekoffset: spwp_data.data('param-weekoffset'),
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('afgelastingen', afgelParams, clientIds, cacheTtlAfgelastingen).then(
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.afgelastingen
							);
							const items = afgelParams.fields
								? spwp_transformDataRows(
										data,
										afgelParams.fields,
										type_sport
									)
								: data;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: afgelParams.fields,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				} else if (spwp_data.data('article') === 'scheidsrechtersaanstellingen') {
				const clientIds = spwp_data.data('client_id');
				const cacheTtlScheidsrechters = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
					const scheidsrechtersParams = {
						aantaldagen: spwp_data.data('param-aantaldagen'),
						weekoffset: spwp_data.data('param-weekoffset'),
						sorteervolgorde: spwp_data.data('param-sorteervolgorde'),
						spelsoort: spwp_data.data('param-spelsoort'),
						aantalregels: spwp_data.data('param-aantalregels'),
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('scheidsrechtersaanstellingen', scheidsrechtersParams, clientIds, cacheTtlScheidsrechters).then(
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.scheidsrechters
							);
							const items = scheidsrechtersParams.fields
								? spwp_transformDataRows(
										data,
										scheidsrechtersParams.fields,
										type_sport
									)
								: data;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: scheidsrechtersParams.fields,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				} else if (spwp_data.data('article') === 'verjaardagen') {
				const clientIds = spwp_data.data('client_id');
				const cacheTtlVerjaardagen = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
					const verjaardagenParams = {
						aantaldagen: spwp_data.data('param-aantaldagen'),
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('verjaardagen', verjaardagenParams, clientIds, cacheTtlVerjaardagen).then(
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.verjaardagen
							);
							const items = verjaardagenParams.fields
								? spwp_transformDataRows(
										data,
										verjaardagenParams.fields,
										type_sport
									)
								: data;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: verjaardagenParams.fields,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				} else if (
					spwp_data.data('article') === 'verenigingsactiviteiten'
				) {
				const clientIds = spwp_data.data('client_id');
				const cacheTtlVereniging = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
					const verenigingParams = {
						aantaldagen: spwp_data.data('param-aantaldagen'),
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('verenigingsactiviteiten', verenigingParams, clientIds, cacheTtlVereniging).then(
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.verenigingsactiviteiten
							);
							const items = verenigingParams.fields
								? spwp_transformDataRows(
										data,
										verenigingParams.fields,
										type_sport
									)
								: data;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: verenigingParams.fields,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				} 
				else if (spwp_data.data('article') === 'vrijwilligerstaken') {
					const clientIds = spwp_data.data('client_id');
					const cacheTtlVrijwilligers = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
					const vrijwilligersParams = {
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('vrijwilligerstaken', vrijwilligersParams, clientIds, cacheTtlVrijwilligers).then(
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.vrijwilligerstaken
							);
							const items = vrijwilligersParams.fields 
								? spwp_transformDataRows(
										data,
										vrijwilligersParams.fields,
										type_sport
									)
								: data;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: vrijwilligersParams.fields,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				}
				else if (spwp_data.data('article') === 'bestuur') {
					const clientIds = spwp_data.data('client_id');
					const cacheTtlBestuur = spwp_data.data('spwp-cache') === 'nee' ? 0 : 86400;
					const bestuurParams = {
						fields: spwp_data.data('fields').split(','),
					};

					spwp_fetchAndMergeMultipleClients('bestuur', bestuurParams, clientIds, cacheTtlBestuur).then(
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.bestuur
							);

							const flatData = data.map((item) => {
								const flat = {};
								function flatten(obj, prefix) {
									for (const key in obj) {
										if (obj.hasOwnProperty(key)) {
											const fullKey = prefix ? prefix + '.' + key : key;
											if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
												flatten(obj[key], fullKey);
											} else {
												flat[fullKey] = obj[key];
											}
										}
									}
								}
								flatten(item, '');
								return flat;
							});

							const items = bestuurParams.fields
								? spwp_transformDataRows(
										flatData,
										bestuurParams.fields,
										type_sport
									)
								: flatData;

							container.append(
								template({
									sport: type_sport,
									items,
									fields: bestuurParams.fields,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				}
			});
		}

		/**
		 *
		 */
		function spwp_addToggleForEachContainer() {
			const programmaContainers = $('.compact_overzicht');

			programmaContainers.each(function () {
				const programmaRegels = $(this).find('.regel');

				if ($(this).hasClass('extradata')) {
					programmaRegels.each(function () {
						const toonMeerButton = $(this).find('.mainData');
						const extradataDiv = $(this).find('.extradata');

						if (
							toonMeerButton.length > 0 &&
							extradataDiv.length > 0
						) {
							toonMeerButton.off('click', spwp_toggleExtraDataDisplay);
							toonMeerButton.on('click', spwp_toggleExtraDataDisplay);
						}
					});
				} else {
					programmaRegels.each(function () {
						$(this).find('.toonmeer').hide();
					});
				}
			});

			/* var programmaContainers = document.querySelectorAll(".compact_overzicht");

      if (programmaContainers.classList.contains("extradata")) {

        programmaContainers.forEach(container => {
          const programmaRegels = container.querySelectorAll(".regel");

          programmaRegels.forEach(regel => {
            const toonMeerButton = regel.querySelector(".mainData");
            const extradataDiv = regel.querySelector(".extradata");

            if (toonMeerButton && extradataDiv) {

              toonMeerButton.removeEventListener("click", spwp_toggleExtraDataDisplay);
              toonMeerButton.addEventListener("click", spwp_toggleExtraDataDisplay);
            }
          });
        });

      } */
		}
		// filter
		if (
			$('#spwp_search').length >= SPWP_CONFIG.CONSTANTS.MIN_ELEMENT_COUNT
		) {
			$('.spwp_searchfield').on('keyup', function () {
				const value = $(this).val().toLowerCase();
				$(this)
					.parents('.spwp_container')
					.find('.regel')
					.each(function () {
						$(this).toggle(
							$(this).text().toLowerCase().indexOf(value) > -1
						);
					});
			});
		}

		// selecteer periode
		if (
			$('#spwp_select_periode').length >=
			SPWP_CONFIG.CONSTANTS.MIN_ELEMENT_COUNT
		) {
			$('#spwp_select_periode').on('change', function () {
				const id = $(this).val();

				$('#sw_stand').hide();
				$('.sw_periodestand').hide();
				$('#' + id).show();
			});
		}

		// get informatie wedstrijd
		/**
		 * Load more match information via accordion
		 *
		 * @param {jQuery} spwp_data - Data container element
		 */
		function spwp_meer_wedstrijd_informatie(spwp_data) {
			const clientIds = spwp_parseClientIds(spwp_data.data('client_id'));
			$('.wedstrijd_informatie_accordion').accordion({
				collapsible: SPWP_CONFIG.UI.ACCORDION.COLLAPSIBLE,
				active: SPWP_CONFIG.UI.ACCORDION.ACTIVE_NONE,
				heightStyle: SPWP_CONFIG.UI.ACCORDION.HEIGHT_STYLE,
				activate(event, ui) {
					const params = {
						wedstrijdcode: $(this).attr('data-code'),
						client_id: clientIds[0],
					};

					$.getJSON(
						api_url + 'wedstrijd-informatie?' + $.param(params),
						function (data) {
							const template = Handlebars.compile(
								spwp_object.templates.wedstrijd_informatie
							);

							const obj = {};
							$.each(data, function (key, row) {
								obj[key] = {};

								$.each(
									row,
									function (data_field_key, data_value) {
										if (
											spwp_is_null_or_undef(data_value) ===
											false
										) {
											obj[key][data_field_key] = '';
										} else {
											obj[key][data_field_key] =
												data_value;
										}
									}
								);
							});

							/* if( data_field_key === 'wedstrijddatetime'){
                obj[data_field_key] = format_programma_date( data_value );
            } */

							ui.newPanel.html(
								template({
									accomodatie: obj.accommodatie,
									kleedkamers: obj.kleedkamers,
									matchofficials: obj.matchofficials,
									officials: obj.officials,
									thuisteam: obj.thuisteam,
									uitteam: obj.uitteam,
									wedstrijdinformatie:
										obj.wedstrijdinformatie,
									labels: spwp_object.labels,
								})
							);
						}
					).fail(function () {
						// Handle errors silently
					});
				},
			});

			/*$(".meer_wedstrijd_informatie").on("click", function(event){
        event.preventDefault();
        var parent_div = $(this).parent();
        var container = $(this).parent().find(".meer_wedstrijd_informatie_container");

        if( parent_div.hasClass("active") ){
          parent_div.removeClass("active");
          container.hide();
        }
        else {
          

          


          setTimeout(function() { 
            parent_div.addClass("active");
          }, 2000);


        }

      });*/
		}
	}

	// init
	spwp_request_data();

	// load programma per team
	$('#programma_teams select').on('change', function () {
		$('#programma_teams_content').hide();

		$.ajax({
			type: 'GET',
			url: spwp_object.rest_url + '/team-content',
			data: {
				post_id: $(this).val(),
				weergave: 'programma',
			},
			dataType: 'json',
		}).done(function (response) {
			if (response.success && response.html) {
				$('#programma_teams_content').html(response.html);
				$('#programma_teams_content').show();
				spwp_request_data();
			}
		});
	});

	// load uitslagen per team
	$('#uitslagen_teams select').on('change', function () {
		$('#uitslagen_teams_content').hide();

		$.ajax({
			type: 'GET',
			url: spwp_object.rest_url + '/team-content',
			data: {
				post_id: $(this).val(),
				weergave: 'uitslagen',
			},
			dataType: 'json',
		}).done(function (response) {
			if (response.success && response.html) {
				$('#uitslagen_teams_content').html(response.html);
				$('#uitslagen_teams_content').show();
				spwp_request_data();
			}
		});
	});

	// load standen per team
	$('#standen_teams select').on('change', function () {
		$('#standen_teams_content').hide();

		$.ajax({
			type: 'GET',
			url: spwp_object.rest_url + '/team-content',
			data: {
				post_id: $(this).val(),
				weergave: 'stand',
			},
			dataType: 'json',
		}).done(function (response) {
			if (response.success && response.html) {
				$('#standen_teams_content').html(response.html);
				$('#standen_teams_content').show();
				spwp_request_data();
			}
		});
	});

	// helpers
	/**
	 * Check if variable is null or undefined
	 *
	 * @param {*} variable - Variable to check
	 * @return {boolean} False if null/undefined, true otherwise
	 */
	function spwp_is_null_or_undef(variable) {
		if (variable === undefined || variable === null) {
			return false;
		}
		return true;
	}
});

Handlebars.registerHelper('isdefined', function (value) {
	return value !== undefined;
});

Handlebars.registerHelper('eq', (a, b) => a === b);

Handlebars.registerHelper('or', function (a, b) {
	return a || b;
});
